/**
 * CreateDocumentTabs Component
 * Tab navigation for selecting document creation method (Text, File, URL)
 * Pure presentational component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab } from '@mui/material';
import {
  TextFields as TextFieldsIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Link as LinkIcon
} from '@mui/icons-material';
import { CreateDocumentTabsProps } from '../types';

export const CreateDocumentTabs: React.FC<CreateDocumentTabsProps> = ({
  value,
  onChange
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Tabs
        value={value}
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
      >
        <Tab
          icon={<TextFieldsIcon />}
          label={t('documents.sourceTypes.text')}
          iconPosition="start"
        />
        <Tab
          icon={<InsertDriveFileIcon />}
          label={t('documents.sourceTypes.file')}
          iconPosition="start"
        />
        <Tab
          icon={<LinkIcon />}
          label={t('documents.sourceTypes.url')}
          iconPosition="start"
        />
      </Tabs>
    </Box>
  );
};
